import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-width": "1.5",
      d: "M16.058 6.667h3.32l.687 2.863m0 0h-1.202v4.379H4.668v1.515l6.239 1.18 2.404 5.108h4.923l2.404-5.109h6.697v-3.256h-2.92L21.267 9.53zm1.66 12.125c0 1.52 1.256 2.751 2.805 2.751s2.805-1.231 2.805-2.75c0-1.52-1.256-2.751-2.805-2.751s-2.805 1.231-2.805 2.75Zm-16.943 0c0 1.52 1.256 2.751 2.805 2.751s2.805-1.231 2.805-2.75c0-1.52-1.256-2.751-2.805-2.751s-2.805 1.231-2.805 2.75Z"
    }, null, -1)
  ]))]))
}
export default { render: render }